import { LoadingButton } from "@mui/lab"
import { Alert, Button, Grid, Typography } from "@mui/material"
import { useState } from "react"
import { Trans, useTranslation } from "react-i18next"
import failureBanner from "../../../../assets/payment_failure_banner.svg"
// import { AppCookies } from "../../../../helpers/cookies"
import { payMembershipSignupFees } from "../../../../helpers/SignupUtils"
import { AcknowledgementPageProps } from "../../../../views/signup-flow/AcknowledgementPage/AcknowledgementPage"
import { SignupRoute } from "../../../../views/signup-flow/SignupFlow/SignupFlow"
import PaymentAcknowledgementBanner from "../../PaymentAcknowledgementBanner"

const PaymentFailurePage = (props: AcknowledgementPageProps) => {
    const { t } = useTranslation(`acknowledgement`)

    const { membershipId, orderId, campaign, onNavigateTo } = props
    const [isTryAgainLoading, setIsTryAgainLoading] = useState<boolean>(false)
    const [hasError, setHasError] = useState<boolean>(false)

    const handleHomeClick = () => {
        if (window.myNtucConfig.signupBackToHomeHomeUrl != undefined) {
            window.location.replace(window.myNtucConfig.signupBackToHomeHomeUrl)
        } else {
            onNavigateTo(SignupRoute.Disclaimer)
        }
    }

    const handleTryAgainClick = () => {
        if (membershipId) {
            setIsTryAgainLoading(true)

            payMembershipSignupFees(parseInt(membershipId))
                .catch(() => {
                    setHasError(true)
                })
                .finally(() => {
                    setIsTryAgainLoading(false)
                })
        }
        else {
            setHasError(true)
        }
    }

    const handleReturnClick = () => {
        if (campaign && campaign.callback) {
            window.location.replace(campaign.callback)
        }
    }

    const isCampaignDefined = () => {
        return campaign && campaign.code && campaign.callback && campaign.app
    }

    return (
        <Grid rowSpacing={3} container justifyContent="center" padding={2}>
            <PaymentAcknowledgementBanner bannerUrl={failureBanner} alt="Payment failure banner" />
            <Grid item justifyContent="center" xs={12}>
                <Typography textAlign="center" variant="h2">{t(`failure.title`)}</Typography>
            </Grid>
            <Grid item justifyContent="center" xs={12}>
                <Typography textAlign="center">{t(`failure.body`)}</Typography>
            </Grid>
            <Grid item justifyContent="center" xs={12}>
                <Typography color="text.secondary" textAlign="center">{t(`failure.reference`)}</Typography>
                <Typography textAlign="center">{orderId}</Typography>
            </Grid>
            <Grid container item xs={12} justifyContent="center" alignItems="center" columnSpacing={2} rowSpacing={3}>
                <Grid item xs={12} md={3} textAlign="center">
                    <LoadingButton loading={isTryAgainLoading} onClick={handleTryAgainClick} variant="contained" color="primary" size="large">
                        {t(`buttons.try_again`)}
                    </LoadingButton>
                </Grid>
                {isCampaignDefined() && <Grid item xs={12} md={3} textAlign="center">
                    <Button onClick={handleReturnClick} variant="outlined" color="primary" size="large">
                        {t(`buttons.return_to`, { app_name: campaign?.app, interpolation: { escapeValue: false } })}
                    </Button>
                </Grid>}
                <Grid item xs={12} md={3} textAlign="center">
                    <Button onClick={handleHomeClick} variant="outlined" color="primary" size="large">
                        {t(`buttons.home`)}
                    </Button>
                </Grid>
            </Grid>
            <Grid item md={12} hidden={!hasError || isTryAgainLoading}>
                <Alert severity="error">
                    <Trans t={t}>failure.unknown_error</Trans>
                </Alert>
            </Grid>
        </Grid>
    )
}

export default PaymentFailurePage
